define(function(require) {

	const getLoginErrorMessage = function(response, respMessage, config) {
		let msg = config.SigninError;

if (response?.statusCode()?.status == 423) {
			msg = i18n.t('CIVICS.LOGIN.MAINT_MODE');
		} else if (respMessage != undefined) {
			if (respMessage.search('locked out') !== -1) msg = config.SigninLockedError;
			if (respMessage.search('User not activated') !== -1) msg = i18n.t('CIVICS.LOGIN.SIGN_IN_NOT_ACTIVATED_ERROR');
			if (respMessage.search('will disable your profile') !== -1) msg = config.SigninError + '<br />' + i18n.t('CIVICS.LOGIN.SIGN_IN_ALMOST_LOCKED_ERROR');
			if (respMessage.search('User not approved') !== -1) msg = i18n.t('CIVICS.LOGIN.SIGN_IN_NOT_APPROVED_ERROR');
			if (respMessage.search('User is expired') !== -1) msg = i18n.t('CIVICS.LOGIN.SIGN_IN_USER_EXPIRED_ERROR');
			if (respMessage.search('Contact is expired') !== -1) msg = i18n.t('CIVICS.LOGIN.SIGN_IN_CONTACT_EXPIRED_ERROR');
			if (respMessage.search('Not sending notification') !== -1 || respMessage.search('notification type') !== -1) msg = i18n.t('CIVICS.LOGIN.SIGN_IN_2FA_ERROR');
			if (respMessage.search('password has expired') !== -1) msg = "";
		}
		return msg;
	};

	return {
		getLoginErrorMessage: getLoginErrorMessage
	};
});
